export default __webpack_public_path__ + "static/media/auditorium_mockup_with_seat.e9eaa568.svg";